// Function to check if the base class name is valid
const isValidBaseClassName = (baseClassName) => {
    return typeof baseClassName === 'string' && baseClassName.trim() !== '';
};

// Function to check if the condition map is valid
const isValidConditionMap = (conditionMap) => {
    return Array.isArray(conditionMap) && conditionMap.every(Array.isArray);
};

// Function to process conditions and add corresponding class names
const processConditions = (classNames, conditionMap) => {
    conditionMap.forEach(([conditionValue, trueClassName, falseClassName]) => {
        if (conditionValue) {
            if (trueClassName && typeof trueClassName === 'string') {
                classNames.push(trueClassName.trim());
            }
        } else {
            if (falseClassName && typeof falseClassName === 'string') {
                classNames.push(falseClassName.trim());
            }
        }
    });
};

// Function to trim class names before adding them to the array
const trimClassName = (className) => {
    return typeof className === 'string' ? className.trim() : className;
};

// Main function to generate class names
export const generateClassNames = (baseClassName, conditionMap = []) => {
    // Check if the base class name is valid
    if (!isValidBaseClassName(baseClassName)) {
        console.error('Invalid base class name. Please provide a non-empty string.');
        return null; // or some other indicator
    }

    // Check if the condition map is valid
    if (!isValidConditionMap(conditionMap)) {
        console.error('Invalid condition map. Please provide an array of arrays.');
        return baseClassName.trim();
    }

    // Process conditions
    const classNames = [trimClassName(baseClassName)];
    processConditions(classNames, conditionMap);

    return classNames.join(' ').trim();
};
